import { render, staticRenderFns } from "./OrderProductsList.vue?vue&type=template&id=0e56f2f7&"
import script from "./OrderProductsList.vue?vue&type=script&lang=js&"
export * from "./OrderProductsList.vue?vue&type=script&lang=js&"
import style0 from "./OrderProductsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports